var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CALCULATOR_DECISIONS, } from './formModel.types';
import { asTypeProxy, makePathModel } from '../../../../utils/nestedPathModel';
import { Schema } from '../../../../adapters/schema';
import constants from './constants';
import { GERMAN_FEDERAL_STATES } from '../../../../apiServices/additionalCharge.service';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
var t = getTranslation(translations);
var initialValues = {
    isBrokerFeePresented: true,
    federalState: 'Berlin',
    decision: CALCULATOR_DECISIONS.NEED_ADVICE,
};
var fields = asTypeProxy();
var PATHS = {
    IS_BROKER_FEE_PRESENTED: fields.isBrokerFeePresented,
    FEDERAL_STATE: fields.federalState,
    DECISION: fields.decision,
    DERIVED_UNDERFUNDING: fields.derivedUnderfunding,
};
var _a = makePathModel(PATHS), paths = _a[0], selectors = _a[1];
var helpers = {
    makeFederalStateOptions: function (values) {
        var emptyOption = {
            label: t.federalStateOption_Empty,
            value: GERMAN_FEDERAL_STATES.UNKNOWN,
        };
        return selectors.FEDERAL_STATE(values) === GERMAN_FEDERAL_STATES.UNKNOWN
            ? __spreadArray([emptyOption], constants.federalStatesOptions, true) : constants.federalStatesOptions;
    },
    isDecisionRequired: function (values) {
        var underfunding = selectors.DERIVED_UNDERFUNDING(values);
        return typeof underfunding === 'undefined' || underfunding > 0;
    },
};
var validationSchema = Schema.object().shape({});
export var additionalChargeCalculatorPageFormModel = {
    initialValues: initialValues,
    paths: paths,
    selectors: selectors,
    helpers: helpers,
    validationSchema: validationSchema,
};
